import Vue from "vue";
import Vuex from "vuex";
import state from "./state";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import { AppModules } from "../modules/store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: AppModules,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
});
